// React
import React from "react";

// Libraries
import PropTypes from "prop-types";
import { Button } from "semantic-ui-react";
import { get } from "lodash";

// Components
import Text from "@Components/Text";

// Styles
import styles from "./styles.module.css";

const InvitationCard = ({ item, onAccept, onReject }) => {
	return (
		<div className={styles.container}>
			<div className={styles.row}>
				<Text className={styles.text}>
					<span className={styles.boldText}>{get(item, "addUser.fullName")}</span>
					<span className={styles.spacerText}>te ha invitado a la compañia</span>
					<span className={styles.boldText}>{get(item, "company.name")}</span>
				</Text>
			</div>
			<div className={styles.row}>
				<Button className={styles.rejectButton} onClick={onReject}>
					Rechazar
				</Button>
				<Button className={styles.acceptButton} onClick={onAccept}>
					Aceptar
				</Button>
			</div>
		</div>
	);
};

InvitationCard.propTypes = {
	item: PropTypes.object,
	onAccept: PropTypes.func,
	onReject: PropTypes.func,
};

export default InvitationCard;
